import { render, staticRenderFns } from "./reporteEscenarioPTISV2.vue?vue&type=template&id=2918ed44"
import script from "./reporteEscenarioPTISV2.vue?vue&type=script&lang=js"
export * from "./reporteEscenarioPTISV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports